import { useLazyQuery, useQuery, QueryResult, LazyQueryResultTuple } from '@apollo/client'
import {
  Country,
  LiveBoardOrHistoryQuery,
  LiveBoardOrHistoryQueryVariables,
  TalentsSeasonSettingsQuery,
  TalentsSeasonSettingsQueryVariables,
} from '../../types'
import { LIVE_BOARD_OR_HISTORY, TALENTS_SEASON_SETTINGS } from './Queries'

export const useTalentsSeasonSettings = (): LazyQueryResultTuple<TalentsSeasonSettingsQuery, TalentsSeasonSettingsQueryVariables> => {
  return useLazyQuery<TalentsSeasonSettingsQuery, TalentsSeasonSettingsQueryVariables>(TALENTS_SEASON_SETTINGS, {
    fetchPolicy: 'network-only',
  })
}

export const useLiveBoardOrHistory = (
  companyId: string,
  country: Country,
  year: number,
): QueryResult<LiveBoardOrHistoryQuery, LiveBoardOrHistoryQueryVariables> => {
  return useQuery<LiveBoardOrHistoryQuery, LiveBoardOrHistoryQueryVariables>(LIVE_BOARD_OR_HISTORY, {
    variables: { companyId, country, year },
    fetchPolicy: 'network-only',
  })
}
